import { tv } from 'tailwind-variants';

const inputStyles = tv({
    slots: {
        wrapper: `
      iris:flex 
      iris:flex-col
      iris:gap-(--comp-space-gap-input)
      `,
        input: `
      iris:peer
      iris:order-2
      iris:flex-[1]
      iris:gap-(--comp-space-gap-input)
      iris:font-(family-name:--comp-type-font-input-value)
      iris:leading-(--comp-type-leading-input-value)!
      iris:tracking-(--comp-type-tracking-input-value)
      iris:duration-(--comp-motion-duration-text-input)
      iris:ease-(--comp-motion-easing-text-input)
      iris:hover:border-(--comp-color-border-input-hover) 
      iris:focus-visible:ring-2
      iris:focus-visible:ring-offset-2
      iris:focus-visible:transition-[ring_var(--comp-motion-duration-focus-ring)_var(--comp-motion-easing-focus-ring)]
    `,
        inputContainer: `
      iris:flex 
      iris:items-center
      iris:gap-(--comp-space-gap-slider-input)
    `,
        labelContainer: `
      iris:min-w-0 
      iris:flex-[2]
      iris:whitespace-nowrap
    `,
        label: `
      iris:order-1
      iris:cursor-auto
      iris:font-(family-name:--comp-type-font-input-label)
      iris:text-(length:--comp-type-size-input-label)
      iris:leading-(--base-type-leading-normal)
      iris:font-(--comp-type-weight-input-label)!
      iris:tracking-(--comp-type-tracking-input-label)
      iris:text-(--comp-color-content-input-label-rest)
      iris:transition-all
      iris:duration-(--comp-motion-duration-text-input)
      iris:ease-(--comp-motion-easing-text-input)
      iris:peer-disabled:cursor-not-allowed
      iris:peer-disabled:opacity-(--sem-opacity-interactive-disabled)
    `,
        inlineMessage: `
      iris:ml-auto
      iris:flex 
     `,
        errorMessage: `
      iris:w-fit
      iris:cursor-auto           
      iris:gap-(--comp-space-gap-input-helper)            
      iris:overflow-hidden
      iris:text-right
      iris:text-(length:--comp-type-size-input-helper)
      iris:break-words
      iris:whitespace-normal
      iris:text-(--comp-color-content-input-helper-error)
    `,
        helperText: `
      iris:overflow-hidden
      iris:text-right
      iris:font-(family-name:--comp-type-font-input-helper)
      iris:text-(length:--comp-type-size-input-helper)
      iris:leading-(--comp-type-leading-input-helper)
      iris:font-(--comp-type-weight-input-helper)!
      iris:tracking-(--comp-type-tracking-input-helper)
      iris:break-words
      iris:whitespace-normal
      iris:text-(--comp-color-content-input-helper-default)
    `,
    },
    variants: {
        variant: {},
        inverse: {
            true: {
                label: `
          iris:text-(--comp-color-content-input-label-inverse-rest)
          iris:peer-focus:text-(--comp-color-content-input-label-inverse-active)
          iris:hover:text-(--comp-color-content-input-label-inverse-hover)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-inverse-active)
        `,
                helperText: "iris:text-(--comp-color-content-input-helper-inverse-default)",
                input: `
          iris:hover:border-(--comp-color-border-input-inverse-hover)
          iris:focus-visible:border-(--comp-color-border-input-inverse-active)
          iris:focus-visible:ring-(--comp-color-border-input-inverse-active)
          iris:focus-visible:ring-offset-(--sem-color-background-neutral-inverse-primary)
          iris:focus-visible:outline-none
          iris:disabled:border-(--comp-color-border-input-inverse-rest)
        `,
                errorMessage: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
            },
            false: {
                input: `
          iris:focus-visible:border-(--comp-color-border-input-active)
          iris:focus-visible:ring-(--comp-color-border-input-active)
          iris:disabled:border-(--comp-color-border-input-rest)
          `,
                label: `
          iris:peer-focus:text-(--comp-color-content-input-label-active)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-active)
        `,
                errorMessage: "iris:hover:text-(--comp-color-content-input-helper-error)",
            },
        },
        error: {
            true: {
                label: `
          iris:text-(--comp-color-content-input-label-rest)
          iris:hover:text-(--comp-color-content-input-label-rest)
        `,
                input: `
          iris:border-(--comp-color-border-input-error)
          iris:bg-(--comp-color-background-input-error)
          iris:peer-focus:text-(--comp-color-content-input-helper-error)
          iris:hover:border-(--comp-color-border-input-error)
          iris:hover:bg-(--comp-color-background-input-error)
          iris:focus:bg-(--comp-color-background-input-error)
          iris:focus-visible:border-(--comp-color-content-input-label-error)
          iris:disabled:border-(--comp-color-border-input-error)
          iris:disabled:hover:border-(--comp-color-border-input-error)
        `,
            },
        },
        disabled: {
            true: {
                helperText: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
                errorMessage: `
          iris:cursor-not-allowed
          iris:opacity-(--sem-opacity-interactive-disabled)
        `,
            },
        },
    },
    compoundVariants: [
        {
            inverse: true,
            error: true,
            class: {
                label: `
          iris:text-(--comp-color-content-input-label-inverse-error)
          iris:peer-focus:text-(--comp-color-content-input-label-inverse-error)
          iris:hover:text-(--comp-color-content-input-label-inverse-error)
          iris:peer-focus:hover:text-(--comp-color-content-input-label-inverse-error)
        `,
                input: `
          iris:border-(--comp-color-border-input-inverse-error)
          iris:bg-(--comp-color-background-input-inverse-rest)
          iris:hover:border-(--comp-color-border-input-inverse-error)
          iris:hover:bg-(--comp-color-background-input-inverse-rest)
          iris:focus:bg-(--comp-color-background-input-inverse-rest)
          iris:focus-visible:border-(--comp-color-border-input-inverse-error)
          iris:disabled:border-(--comp-color-border-input-inverse-error)
          iris:disabled:hover:border-(--comp-color-border-input-inverse-error)
        `,
            },
        },
    ],
    defaultVariants: {
        inverse: false,
        error: false,
        disabled: false,
    },
});

export { inputStyles as default };
